import { render, staticRenderFns } from "./AppointmentBlock.vue?vue&type=template&id=d0faa530&scoped=true"
import script from "./AppointmentBlock.vue?vue&type=script&lang=js"
export * from "./AppointmentBlock.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBlock.vue?vue&type=style&index=0&id=d0faa530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0faa530",
  null
  
)

export default component.exports